<template>
  <VPopup
    :target="target"
    show-pointer
    align="right"
    :visible="true"
    @close="$core.dialogs.OrderSumListPopup.resolve()"
  >
    <dl id="order-sum-list">
      <div
        v-for="([code, sums]) in Array.from(sumList)"
        :key="code"
      >
        <dt>Итого</dt>     <dd>{{ sums.sumFullSeller.format(code) }}</dd>
        <dt>НДС в т.ч</dt> <dd>{{ sums.vatSumSeller.format(code) }}</dd>
      </div>
    </dl>
  </VPopup>
</template>

<style lang="scss"  src="./OrderSumListPopup.scss"/>

<script lang="ts">
import Order from "@/domains/Orders/Order";
import Sum   from "@/core/types/Sum";

export default defineComponent({
  name: 'OrderSumListPopup',

  emits: ['close'],

  props: {
    order: {
      type: Object as PropType<Order>,
      required: true,
    },
    target: {
      type: HTMLElement,
      default: null,
    },
  },

  computed: {
    /**
     * Суммы заказа, сгруппированные по валютам позиций. Нужны там, где
     * заказ мультивалютный: одной суммой такой заказ не описывается,
     * складывать разные валюты нельзя.
     */
    sumList(): Map<string, { sumFullSeller: Sum; vatSumSeller: Sum }> {
      const result = new Map<string, { sumFullSeller: Sum; vatSumSeller: Sum }>();

      this.order.positions.forEach((position) => {
        const current = result.get(position.currencyCode) ?? { sumFullSeller: Sum.zero(), vatSumSeller: Sum.zero() };

        result.set(position.currencyCode, {
          sumFullSeller: current.sumFullSeller.plus(position.sumFullSeller),
          vatSumSeller:  current.vatSumSeller.plus(position.vatSumSeller),
        });
      });

      return result;
    },
  }
});
</script>
